


function Selector(selector) {
  var els = document.querySelectorAll(selector);
  
  var self = this;
  [].forEach.call(els, function(el) {
    self.push(el);
  });
}

function Plugins() {}

Plugins.prototype = new Array();

var fn = new Plugins();
Selector.prototype = fn;


fn.each = function(fn) {
  this.forEach(function(el) {
    fn.call(el);
  });
  return this;
};



function $(selector) {
  if( selector instanceof Document ) {
    return {
      ready: function(fn) {
        document.addEventListener('DOMContentLoaded', function() {
          fn($);
        });
      }
    };
  }
  
  return new Selector(selector);
}

$.fn = fn;


module.exports = $;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/index.js
 ** module id = 0
 ** module chunks = 0
 **/